import { useState, useEffect } from "react";
import { ReactTransliterate } from "react-transliterate";
import editIcon from "../../assests/icons/edit.jpg";
import downloadIcon from "../../assests/icons/download.png";
import deleteIcon from "../../assests/icons/delete.jpg";
import publishIcon from "../../assests/icons/publish.png";
import { isAdmin, isApprover, isPublisher } from "../utils/auth.js";
import { getYears } from "../../network/lib/masterData.js";
import {
  ahavalObject,
  save,
  update,
  deleteLive,
  deletePreview,
  publish,
  getPreviewPeriod,
  getLivePeriod,
  getPreviewByPeriod,
  getLiveByPeriod,
  download,
} from "../../network/lib/ahaval.js";
import { convertToNumerals, showHideLoader } from "../utils/helper.js";

function Ahaval({ user }) {
  const [years, setYears] = useState();
  const [previewPeriods, setPreviewPeriods] = useState();
  const [livePeriods, setLivePeriods] = useState();
  const [previewPeriod, setPreviewPeriod] = useState("");
  const [livePeriod, setLivePeriod] = useState("");
  const [fileName, setFileName] = useState("");
  const [uploadingFileName, setUploadingFileName] = useState("");
  const [fromPeriod, setFromPeriod] = useState("1");
  const [toPeriod, setToPeriod] = useState("1");
  const [image, setImage] = useState("");
  const [file, setFile] = useState();
  const [fileBase64, setFileBase64] = useState("");
  const [previewData, setPreviewData] = useState();
  const [liveData, setLiveData] = useState();

  const [id, setId] = useState(0);

  const admin = isAdmin(user.roleId);
  const approver = isApprover(user.roleId);
  const publisher = isPublisher(user.roleId);

  useEffect(() => {
    !years && populateYears();
  }, []);

  const populatePreviewPeriods = () => {
    getPreviewPeriod().then((res) => {
      if (res.status == 200) {
        setPreviewPeriods(res.data);
      }
    });
  };

  const populateLivePeriods = () => {
    getLivePeriod().then((res) => {
      if (res.status == 200) {
        setLivePeriods(res.data);
      }
    });
  };

  const populateYears = () => {
    getYears().then((res) => {
      if (res.status == 200) {
        setYears(res.data);
      }
    });
  };

  const setToDefault = () => {
    setFileName("");
    setUploadingFileName("");
    setFromPeriod("1");
    setToPeriod("1");
    setImage("");
    setId(0);
    setPreviewData(undefined);
    setLiveData(undefined);
    setFile(null);
    setFileBase64("");
  };

  const handleCancel = (e) => {
    e.preventDefault();
    resetMessage();
    setToDefault();
  };

  const resetMessage = () => {
    let message = document.getElementById("message");
    message.innerHTML = "";
    message.classList.replace("success", "alert");
    return message;
  };

  const handleEdit = (e) => {
    e.preventDefault();
    resetMessage();

    let dataParams = e.target.getAttribute("data-params");
    if (dataParams) {
      let params = JSON.parse(dataParams);
      setId(params.id);
      setFileName(params.fileName);
      setFromPeriod(params.fromPeriodId);
      setToPeriod(params.toPeriodId);
      setImage(params.image);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let message = resetMessage();

    setLiveData(undefined);
    setPreviewData(undefined);

    let fromPeriodText = years.find((x) => x.id == parseInt(fromPeriod)).name;
    let toPeriodText = years.find((x) => x.id == parseInt(toPeriod)).name;

    if (convertToNumerals(fromPeriodText) > convertToNumerals(toPeriodText)) {
      message.innerHTML =
        "Please select valid 'To Period'. 'From Period' cannot be greater than 'To Period'";
    } else if (!fileName) {
      message.innerHTML = "Please provide File Name";
    } else if (!file && id == 0) {
      message.innerHTML = "Please select a File";
    } else {
      showHideLoader(true);

      const formData = new FormData();
      formData.append("Id", id);
      formData.append("File", file);
      formData.append("Image", image);
      formData.append("FileName", fileName.trim());
      formData.append("FromPeriodId", fromPeriod);
      formData.append("ToPeriodId", toPeriod);
      formData.append("UserName", user.userName);

      if (id == 0) {
        save(formData).then((res) => {
          if (res.status == 200 && res.data) {
            message.classList.replace("alert", "success");
            message.innerHTML = "Data saved successfully!!!";
            setToDefault();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
          showHideLoader();
        });
      } else {
        update(formData).then((res) => {
          if (res.status == 200 && res.data) {
            message.classList.replace("alert", "success");
            message.innerHTML = "Data updated successfully!!!";
            setToDefault();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
          showHideLoader();
        });
      }
    }
  };

  const fetchPreviewData = (period) => {
    showHideLoader(true);
    getPreviewByPeriod(period)
      .then((resp) => {
        if (resp.status == 200) {
          setPreviewData(resp.data);
          setLiveData(undefined);
          populatePreviewPeriods();
          showHideLoader();
        }
      })
      .catch((e) => console.log(e));
  };

  const handlePreviewData = (e) => {
    e.preventDefault();
    resetMessage();
    fetchPreviewData("");
    setPreviewPeriod("");
  };

  const fetchLiveData = (period) => {
    showHideLoader(true);

    getLiveByPeriod(period)
      .then((resp) => {
        if (resp.status == 200) {
          setLiveData(resp.data);
          setPreviewData(undefined);
          populateLivePeriods();
          showHideLoader();
        }
      })
      .catch((e) => console.log(e));
  };

  const handleLiveData = (e) => {
    e.preventDefault();
    resetMessage();
    fetchLiveData("");
    setLivePeriod("");
  };

  const handleDeletePreview = (e) => {
    e.preventDefault();
    let message = resetMessage();
    if (window.confirm("Do you really want to delete the item from Preview?")) {
      let params = e.target.getAttribute("data-params");
      if (params) {
        const formData = new FormData();
        formData.append("Id", parseInt(params));
        formData.append("UserName", user.userName);

        deletePreview(formData).then((res) => {
          if (res.status == 200 && res.data) {
            fetchPreviewData("");
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
        });
      }
    }
  };

  const handleDeleteLive = (e) => {
    e.preventDefault();
    let message = resetMessage();
    if (
      window.confirm(
        "Do you really want to delete the item from Live? This will be moved to Preview."
      )
    ) {
      let params = e.target.getAttribute("data-params");
      if (params) {
        const formData = new FormData();
        formData.append("Id", parseInt(params));
        formData.append("UserName", user.userName);

        deleteLive(formData).then((res) => {
          if (res.status == 200 && res.data) {
            fetchLiveData("");
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
        });
      }
    }
  };

  const handlePublish = (e) => {
    e.preventDefault();
    let message = resetMessage();

    let params = e.target.getAttribute("data-params");
    if (params) {
      const formData = new FormData();
      formData.append("Id", parseInt(params));
      formData.append("UserName", user.userName);

      publish(formData).then((res) => {
        if (res.status == 200 && res.data) {
          fetchPreviewData("");
          setToDefault();
        } else {
          message.innerHTML = "Some error occurred. Please try again";
        }
      });
    }
  };

  const handleDownload = (e) => {
    e.preventDefault();
    let message = resetMessage();
    showHideLoader(true);

    let params = e.target.getAttribute("data-params");
    if (params) {
      download(params).then((res) => {
        if (res.status == 200 && res.data) {
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(new Blob([res.data]));
          link.download = params.split("^$$!$$^")[1];
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          showHideLoader();
        } else {
          message.innerHTML = "Some error occurred. Please try again";
          showHideLoader();
        }
      });
    }
  };

  const handleImage = (e) => {
    let message = resetMessage();
    let file = e.target.files[0];
    if (file.size > 26214400) {
      message.innerHTML = "File size cannot be greater than 25MB";
      return;
    }
    setUploadingFileName(file.name);
    !fileName && setFileName(file.name);
    setFile(file);
    setImage("");
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setFileBase64(reader.result);
    };
  };

  const acceptedFileType = `application/pdf, application/vnd.ms-powerpoint,
     application/vnd.openxmlformats-officedocument.presentationml.presentation, text/plain,
      application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv
      application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document`;

  const contents = (
    <>
      <table>
        <tbody>
          <tr>
            <th align="center" colSpan="4">
              Ahaval Upload
            </th>
          </tr>
          <tr>
            <td align="right">
              <span>From Period</span>
            </td>
            <td>
              {years && (
                <select
                  onChange={(e) => setFromPeriod(e.target.value)}
                  value={fromPeriod}
                  style={{ width: "322px" }}
                >
                  {years.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
            <td align="right">
              <span>To Period</span>
            </td>
            <td>
              {years && (
                <select
                  onChange={(e) => setToPeriod(e.target.value)}
                  value={toPeriod}
                  style={{ width: "322px" }}
                >
                  {years.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
          </tr>
          <tr>
            <td align="right">
              <span className="required">File Name</span>
            </td>
            <td colSpan={3}>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="1" cols="107" />
                )}
                value={fileName}
                onChangeText={(text) => {
                  setFileName(text.trim());
                }}
                lang="mr"
              />
            </td>
          </tr>
          <tr>
            <td align="right">
              <span className="required">File</span>
            </td>
            <td>
              <label
                htmlFor="file-upload"
                className="custom-file-upload"
                style={{ width: "307px", textAlign: "center" }}
              >
                Browse
              </label>
              <input
                type="file"
                id="file-upload"
                accept={acceptedFileType}
                onChange={(e) => handleImage(e)}
              />
            </td>
            <td colSpan={2}>
              {fileBase64 ? (
                <a
                  href={fileBase64}
                  className="file-download"
                  download={fileName.trim()}
                >
                  {uploadingFileName}
                </a>
              ) : (
                image && (
                  <img
                    className="handle"
                    data-params={image}
                    data-fileName={fileName}
                    onClick={handleDownload}
                    src={downloadIcon}
                    alt="Download"
                    border="0px"
                    style={{ width: "20px", height: "20px" }}
                  />
                )
              )}
            </td>
          </tr>
          <tr>
            <td colSpan={2}></td>
            <td
              colSpan={2}
              style={{ textAlign: "right", paddingRight: "56px" }}
            >
              <input
                className="btn"
                type="submit"
                value="Cancel"
                id="btnCancel"
                onClick={handleCancel}
              />
              &nbsp;&nbsp;
              <input
                className="btn"
                type="submit"
                value="Submit"
                id="btnSubmit"
                onClick={handleSubmit}
              />
            </td>
          </tr>
          <tr>
            <td colSpan="4" style={{ textAlign: "center" }}>
              <div
                id="message"
                className="alert"
                style={{ textAlign: "center" }}
              ></div>
            </td>
          </tr>
          <tr>
            <td></td>
            <td colSpan={2}>
              <input
                className="btn"
                type="submit"
                style={{ float: "left" }}
                value="View Preview"
                id="btnPreviewData"
                onClick={handlePreviewData}
              />
              &nbsp;&nbsp;
              <input
                className="btn"
                type="submit"
                value="View Live"
                id="btnLiveData"
                onClick={handleLiveData}
              />
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
      {previewData && (
        <table className="alternate-row">
          <thead>
            <tr>
              <th align="center" colSpan={admin ? 6 : approver ? 5 : 4}>
                Preview
              </th>
            </tr>
            <tr align="center">
              <td colSpan={admin ? 6 : approver ? 5 : 4}>
                <span>Period: </span>
                {previewPeriods && (
                  <select
                    onChange={(e) => {
                      setPreviewPeriod(e.target.value);
                      fetchPreviewData(e.target.value);
                    }}
                    value={previewPeriod}
                    style={{ width: "322px" }}
                  >
                    <option value="">All</option>
                    {previewPeriods.map((x, i) => (
                      <option key={i} value={x}>
                        {x}
                      </option>
                    ))}
                  </select>
                )}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr style={{ textAlign: "center" }}>
              {publisher && (
                <td>
                  <u>Publish</u>
                </td>
              )}
              <td>
                <u>File Name</u>
              </td>
              <td>
                <u>Period</u>
              </td>
              <td>
                <u>Document</u>
              </td>
              <td>
                <u>Edit</u>
              </td>
              {admin && (
                <td>
                  <u>Delete</u>
                </td>
              )}
            </tr>
            {previewData.length > 0 ? (
              previewData.map((x, i) => (
                <tr key={i} style={{ textAlign: "center" }}>
                  {publisher && (
                    <td>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handlePublish}
                        src={publishIcon}
                        alt="Publish"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                  <td width="20%">{x.fileName}</td>
                  <td>{x.period}</td>
                  <td>
                    <img
                      className="handle"
                      data-params={x.image}
                      data-fileName={x.fileName}
                      onClick={handleDownload}
                      src={downloadIcon}
                      alt="Download"
                      border="0px"
                      style={{ width: "20px", height: "20px" }}
                    />
                  </td>
                  <td>
                    <img
                      className="handle"
                      data-params={JSON.stringify(x)}
                      onClick={handleEdit}
                      src={editIcon}
                      alt="Edit"
                      border="0px"
                      style={{ width: "20px", height: "20px" }}
                    />
                  </td>
                  {admin && (
                    <td>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handleDeletePreview}
                        src={deleteIcon}
                        alt="Delete"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={admin ? 6 : approver ? 5 : 4}
                  style={{ textAlign: "center" }}
                >
                  No Data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      {liveData && (
        <table className="alternate-row">
          <thead>
            <tr>
              <th align="center" colSpan={admin ? 4 : 3}>
                Live
              </th>
            </tr>
            <tr align="center">
              <td colSpan={admin ? 4 : 3}>
                <span>Period: </span>
                {livePeriods && (
                  <select
                    onChange={(e) => {
                      setLivePeriod(e.target.value);
                      fetchLiveData(e.target.value);
                    }}
                    value={livePeriod}
                    style={{ width: "322px" }}
                  >
                    <option value="">All</option>
                    {livePeriods.map((x, i) => (
                      <option key={i} value={x}>
                        {x}
                      </option>
                    ))}
                  </select>
                )}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr style={{ textAlign: "center" }}>
              <td>
                <u>Name</u>
              </td>
              <td>
                <u>Period</u>
              </td>
              <td>
                <u>Document</u>
              </td>
              {admin && (
                <td>
                  <u>Delete</u>
                </td>
              )}
            </tr>
            {liveData.length > 0 ? (
              liveData.map((x, i) => (
                <tr key={i} style={{ textAlign: "center" }}>
                  <td width="20%">{x.fileName}</td>
                  <td>{x.period}</td>
                  <td>
                    <img
                      className="handle"
                      data-params={x.image}
                      data-fileName={x.fileName}
                      onClick={handleDownload}
                      src={downloadIcon}
                      alt="Download"
                      border="0px"
                      style={{ width: "20px", height: "20px" }}
                    />
                  </td>
                  {admin && (
                    <td>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handleDeleteLive}
                        src={deleteIcon}
                        alt="Delete"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={admin ? 4 : 3} style={{ textAlign: "center" }}>
                  No Data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </>
  );

  return contents;
}

export default Ahaval;
